import React from 'react';
import { Message } from 'semantic-ui-react';
import { AVAILABLE_TRANSLATION_LANGUAGES } from '../../../../constants/translations';

const FIELD_LABELS = {
  name: 'Name',
  description: 'Description',
  question: 'Question text',
  value: 'Condition value',
  values: 'Lookup value',
};

const languageName = (code) => {
  const language = AVAILABLE_TRANSLATION_LANGUAGES.find(({ value }) => value === code);
  return language ? language.text : code;
};

export const formatTranslationWarning = (warning) => {
  const path = Array.isArray(warning.path)
    ? warning.path.filter(value => typeof value === 'string' && value.trim())
    : [];
  const location = path.length > 0
    ? path.join(' → ')
    : 'Questionnaire content';
  const field = FIELD_LABELS[warning.field] || warning.field;
  const lookupPosition = warning.field === 'values' && Number.isInteger(warning.valueIndex)
    ? ` ${warning.valueIndex + 1}`
    : '';
  const details = [
    field ? `${field}${lookupPosition}` : null,
    warning.language ? languageName(warning.language) : null,
  ].filter(Boolean).join(' · ');

  return { location, details };
};

export const visibleTranslationWarnings = questionaire =>
  (Array.isArray(questionaire?.translationWarnings) ? questionaire.translationWarnings : [])
    .filter(warning => warning && warning.code !== 'unchanged_source_text' && warning.field !== 'questionTag' &&
      typeof warning.message === 'string' && warning.message.trim() &&
      Array.isArray(warning.path) && warning.path.some(value => typeof value === 'string' && value.trim()));

export const hasTranslationWarnings = questionaire => visibleTranslationWarnings(questionaire).length > 0;

export const TranslationWarnings = ({ questionaire }) => {
  const warnings = visibleTranslationWarnings(questionaire);
  if (!warnings.length) return null;

  return (
    <Message color="orange">
      <Message.Header>
        Review {warnings.length} translation warning(s)
      </Message.Header>
      <p>
        Review these translation notes. They do not prevent preparing or publishing a WhatsApp Flow.
      </p>
      {warnings.length > 0 && (
        <ul>
          {warnings.map((warning, index) => {
            const { location, details } = formatTranslationWarning(warning);
            return (
              <li key={`${location}-${details}-${index}`}>
                <strong>{location}</strong>
                {details && ` — ${details}`}
                {warning.message && <p>{warning.message}</p>}
              </li>
            );
          })}
        </ul>
      )}
    </Message>
  );
};
